import { General } from "../../types/Page";

export default {
  [General.TITLE]: 'Katalog',
}
